module.exports = __webpack_public_path__ + "static/night-school-c605e9145e19006ef541500ba1cdeb7a.jpg";